import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_PRIMARY_COLOR } from '../config';

const userDefault = {
  primaryColor: DEFAULT_PRIMARY_COLOR,
}

export const userSlice = createSlice({
    name: 'user',
    initialState: {
      value: userDefault,
    },
    reducers: {
      setUser: (state, action) => {
        state.value = {
          ...state.value,
          ...action.payload,
        };
      },
      unSetUser: state => {
        state.value = userDefault;
      }
    }
})

export const { 
  setUser, 
  unSetUser, 
} = userSlice.actions;

export default userSlice.reducer;